import React, { useState, useEffect } from 'react';
import Question from './Question';
import axios from 'axios';
import Cookies from 'js-cookie';
import "./Form.css";
import { validate, clean } from 'rut.js';
import phoneCode from './PhoneCode';
import { adapterForm } from '../../Adapter';
import cityImage from '../../img/Santiago.png';
import Header from '../Header/Header';
import { NextButton } from './NextButton';
import { BackButton } from './BackButton';
import { type } from '@testing-library/user-event/dist/type';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

//Funciones de validación
function validarRut(rut) {
    if (!rut || typeof rut !== 'string' || rut.trim() === '') {
        return false;
    }
    const rutLimpio = clean(rut);
    return validate(rutLimpio);
}

// Función para enviar los datos al backend
const sendDataToBackend = async (token, datos) => {
    try {
        //datos profesion 2
        // Transforma los nombres de los campos según lo que espera el backend
        const dataToSend = adapterForm(datos); // el adapterForm hace que los datos esten en el formato del back
        // Realiza la solicitud PATCH
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users/edit_profile`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(dataToSend),
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error(`Error en la solicitud PATCH: ${errorMessage}`);
        } else {
            // Verificar si la respuesta tiene contenido antes de parsear
            const responseText = await response.text();
            if (responseText) {
                const jsonResponse = JSON.parse(responseText);
                console.log('Datos enviados exitosamente');
            } else {
                console.log('Datos enviados exitosamente, sin respuesta JSON');
            }
        }
    } catch (error) {
        console.error('Error en la solicitud PATCH:', error);
    }
};

export async function update_cv(token, formData){
    try{
        const response = await axios.patch(`${process.env.REACT_APP_API_URL}/users/updatecv`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error(error);
    }
}


//Componente Formulario
const Form = () => {
    const [datos, setDatos] = useState({});
    const datosPaises = JSON.parse(localStorage.getItem('datosPaises'));
    const datosRegion = JSON.parse(localStorage.getItem('datosRegion'));
    const [currentStep, setCurrentStep] = useState(1);
    const [rutValido, setRutValido] = useState(true);
    const [celValido, setCelValido] = useState(true);
    const [codigoTelefonico, setCodigoTelefonico] = useState('+56');
    const datosCarreras = JSON.parse(localStorage.getItem('datosCarreras'));
    const datosUniversidades = JSON.parse(localStorage.getItem('datosUniversidades'));
    const datosTamanoEquipos = JSON.parse(localStorage.getItem('datosTamano'));
    const datosIndustrias = JSON.parse(localStorage.getItem('datosIndustrias'));
    const aniosExperiencia = JSON.parse(localStorage.getItem('aniosExperiencia'));
    const competencias = JSON.parse(localStorage.getItem('competencias'));
    const areasExperiencia = JSON.parse(localStorage.getItem('areasExperiencia'));
    const disponibilidades = JSON.parse(localStorage.getItem('disponibilidades'));
    const jornadas = JSON.parse(localStorage.getItem('jornadas'));
    const modalidades = JSON.parse(localStorage.getItem('modalidades'));
    const idiomas = JSON.parse(localStorage.getItem('idiomas'));
    const conocio = JSON.parse(localStorage.getItem('conocio'));
    const datosLenguajesProgramacion = JSON.parse(localStorage.getItem('datosLenguajesProgramacion'));
    const datosTecnologias = JSON.parse(localStorage.getItem('datosTecnologias'))
    const datosTiposDb = JSON.parse(localStorage.getItem('datosTiposDb'));
    const datosPlataformas = JSON.parse(localStorage.getItem('datosPlataformas'))
    const datosCultivos = JSON.parse(localStorage.getItem('datosCultivos'))
    const datosControlPlagas = JSON.parse(localStorage.getItem('datosControlPlagas'));
    const datosSistemasMecanicos = JSON.parse(localStorage.getItem('datosSistemasMecanicos')); 
    const datosHerramietasDiagnostico = JSON.parse(localStorage.getItem('datosHerramietasDiagnostico'));
    const datosEquipos = JSON.parse(localStorage.getItem('datosEquipos'));
    const datosSoftGestion = JSON.parse(localStorage.getItem('datosSoftGestion')); 
    const datosTipoMineria = JSON.parse(localStorage.getItem('datosTipoMineria')); 
    const datosSoftMinero = JSON.parse(localStorage.getItem('datosSoftMinero')); 
    const datosProcesosExtraccion = JSON.parse(localStorage.getItem('datosProcesosExtraccion'));
    const [selectedPueblo, setSelectedPueblo] = useState('');
    const [selectedFactor, setSelectedFactor] = useState('');
    const [selectedCompromiso, setSelectedCompromiso] = useState('');
    const [selectedLenguajes, setSelectedLenguajes] = useState('');
    const [selectedTecnologias, setSelectedTecnologias] = useState('');
    const [selectedTiposDb, setSelectedTiposDb] = useState('');
    const [selectedPlataformas, setSelectedPlataformas] = useState('');
    const [selectedCultivos, setSelectedCultivos] = useState('');
    const [selectedPlagas, setSelectedPlagas] = useState('');
    const [selectedSistemasMecanicos, setSelectedSistemasMecanicos] = useState('')
    const [selectedMantenimiento, setSelectedMantenimiento] = useState('');
    const [selectedIndustrias, setSelectedIndustrias] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedCompetencias, setSelectedCompetencias] = useState([]);
    const [selectedIdiomas, setSelectedIdiomas] = useState([]);
    const [selectedDisponibilidad, setSelectedDisponibilidad] = useState([]);
    const [selectedHerramientasDiagnostico, setSelectedHerramientasDiagnostico] = useState([]);
    const [selectedEquiposExperiencia, setSelectedEquiposExperiencia] = useState([]);
    const [selectedSoftwareGestion, setSelectedSoftwareGestion] = useState([]);
    const [selectedTipoMineria, setSelectedTipoMineria] = useState([]);
    const [selectedSoftwareMinero, setSelectedSoftwareMinero] = useState([]);
    const [selectedProcesos, setSelectedProcesos] = useState([]);
    const [file, setFile] = useState(null);
    const [contacto1, setContacto1] = useState('');
    const [contacto2, setContacto2] = useState('');
    const [contactos, setContactos] = useState([]);
    const [universidad, setUniversidad] = useState(0);
    const [rolAdicional, setRolAdicional] = useState("");
    const [mostrarRegion, setMostrarRegion] = useState(false); 
    const [cargoRelevante, setCargoRelevante] = useState(""); 
    const [liderazgo, setLiderazgo] = useState("");
    const [questions, setQuestions] = useState([]);
    const [industryQuestions, setIndustryQuestions] = useState({});
    const [industryStepIndex, setIndustryStepIndex] = useState(-1);
    const [processedQuestions, setProcessedQuestions] = useState([]);

    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (datos.cargoRelevante === '0'){
            setDatos((prevState) => ({
                ...prevState,
                cargo_relevante: null,
                empresa_relevante: null,
                id_industria_relevante: null,
            }));
        }
        if(datos.rolAdicional === '0'){
            setDatos((prevState) => ({
                ...prevState,
                cargo_adicional: null,
                empresa_adicional: null,
                id_industria_adicional: null,
            }));
        }
        datos.contactos = [contacto1, contacto2];
        const token = localStorage.getItem('jwtToken');
        await sendDataToBackend(token, datos);  // Envía los datos al backend 
        console.log('Formulario enviado.');
        navigate('/profile');
    };
    
    // manejo del cv 
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
    };

    const handleFile = async (event) => {
        alert('Se está subiendo el archivo, espere unos segundos antes de continuar');
        event.preventDefault();
        var formData = new FormData();
        formData.append('pdf', file);
        for (var key of formData.entries()) {
            }
        const jwtToken = localStorage.getItem('jwtToken')
        const response =  await update_cv(jwtToken, formData);
        if (response.status === 200){
            window.alert('Se ha subido el archivo correctamente');
        }
        else{
            window.alert('Ha ocurrido un error');
        }
    };

    const handleStepChange = (step) => {
        setCurrentStep(step);
    };
    
    //manejo de los multi-selects
    const handleSelectionChange = (selectedOptions, name) => {
        if (selectedOptions.length > 5) {
            alert('No puedes seleccionar más de 5 opciones');
            return
        }
        if (name === 'industriasExperiencia') {
            setSelectedIndustrias(selectedOptions);
            const industriasSeleccionadas = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, industrias: industriasSeleccionadas }));
        }
        if (name === 'competencias') {
            setSelectedCompetencias(selectedOptions);
            const competenciasSeleccionadas = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, competencias: competenciasSeleccionadas }));
        }
        if (name === 'areas') {
            setSelectedAreas(selectedOptions);
            const areasSeleccionadas = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, areas: areasSeleccionadas }));

        }
        if (name === 'idiomas') {
            setSelectedIdiomas(selectedOptions);
            const idiomasSeleccionados = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, idiomas: idiomasSeleccionados }));
        }
        if (name === 'disponibilidad') {
            setSelectedDisponibilidad(selectedOptions);
            const disponibilidadSeleccionada = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, disponibilidades: disponibilidadSeleccionada }));
        }
        if (name === 'lenguajesExperiencia'){
            setSelectedLenguajes(selectedOptions); 
            const lenguajesSeleccionados = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, lenguajes: lenguajesSeleccionados }));
        }
        if (name === 'tecnologiasExperiencia') {
            setSelectedTecnologias(selectedOptions); 
            const tecnologiasSeleccionadas = selectedOptions.map(option => ({ id: option.value }));
            setDatos(prevState => ({ ...prevState, tecnologias: tecnologiasSeleccionadas }));
        }
        if (name === 'tipoDb') {
            setSelectedTiposDb(selectedOptions); 
            const tiposDbSeleccionados = selectedOptions.map(option => ({ id: option.value}));
            setDatos(prevState => ({ ...prevState, tipoDb: tiposDbSeleccionados})); 
        }
        if (name === 'plataformasExperiencia') {
            setSelectedPlataformas(selectedOptions); 
            const plataformasSeleccionadas = selectedOptions.map(option => ({ id: option.value}));
            setDatos(prevState => ({ ...prevState, plataformas: plataformasSeleccionadas})); 
        }

        if (name === 'cultivosExperiencia') {
            setSelectedCultivos(selectedOptions); 
            const cultivosSeleccionados = selectedOptions.map(option => ({ id: option.value}));
            setDatos(prevState => ({ ...prevState, cultivos: cultivosSeleccionados}))
        }

        if (name === 'plagas') {
            setSelectedPlagas(selectedOptions); 
            const plagasSeleccionadas = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, plagas: plagasSeleccionadas}));
        }

        if (name === 'sistemasMecanicosExperiencia' ) {
            setSelectedSistemasMecanicos(selectedOptions); 
            const sistemasSeleccionados = selectedOptions.map(option => ({id: option.value})); 
            setDatos(prevState => ({ ...prevState, sistemasMecanicosExperiencia: sistemasSeleccionados}));
        }

        if (name === 'experienciaMantenimiento') {
            setSelectedMantenimiento(selectedOptions); 
            const mantenimientoSeleccionado = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, experienciaMantenimiento: mantenimientoSeleccionado}));
        }

        if (name === 'herramientasDiagnostico') {
            setSelectedHerramientasDiagnostico(selectedOptions); 
            const herramientasSeleccionadas = selectedOptions.map(option => ({ id: option.value}));
            setDatos(prevState => ({ ...prevState, herramientasDiagnostico: herramientasSeleccionadas}));
        }

        if (name === 'equiposExperiencia') {
            setSelectedEquiposExperiencia(selectedOptions); 
            const equiposSeleccionados = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, equiposExperiencia: equiposSeleccionados}));
        }

        if (name === 'softwareGestion') {
            setSelectedSoftwareGestion(selectedOptions); 
            const softwaresSeleccionados = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, softwareGestion: softwaresSeleccionados}));
        }

        if (name === 'tipoMineria') {
            setSelectedTipoMineria(selectedOptions);
            const tipoSeleccionados = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, tipoMineria: tipoSeleccionados}));
        }

        if (name === 'softwareMinero') {
            setSelectedSoftwareMinero(selectedOptions); 
            const softwaresSeleccionados = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, softwareMinero: softwaresSeleccionados}));
        }

        if (name === 'procesos') {
            setSelectedProcesos(selectedOptions); 
            const procesosSeleccionados = selectedOptions.map(option => ({ id: option.value})); 
            setDatos(prevState => ({ ...prevState, procesos: procesosSeleccionados}));
        }

    };

    //manejo de los contactos de referencia
    const handleContactos = (event) => {
        const { name, value } = event.target;
        
        setDatos(prevState => ({
            ...prevState,
            [name]: value,
        }));
        
        if (name === "contacto_nombre1" && contacto1[0] !== value) {
            let copiaContacto = [...contacto1];
            copiaContacto[0] = value;
            setContacto1(copiaContacto);
        } else if (name === "contacto_celular1" && contacto1[2] !== value) {
            let copiaContacto = [...contacto1];
            copiaContacto[2] = value;
            setContacto1(copiaContacto);
        } else if (name === "contacto_mail1" && contacto1[1] !== value) {
            let copiaContacto = [...contacto1];
            copiaContacto[1] = value;
            setContacto1(copiaContacto);
        } else if (name === "contacto_nombre2" && contacto2[0] !== value) {
            let copiaContacto = [...contacto2];
            copiaContacto[0] = value;
            setContacto2(copiaContacto);
        } else if (name === "contacto_celular2" && contacto2[2] !== value) {
            let copiaContacto = [...contacto2];
            copiaContacto[2] = value;
            setContacto2(copiaContacto);
        } else if (name === "contacto_mail2" && contacto2[1] !== value) {
            let copiaContacto = [...contacto2];
            copiaContacto[1] = value;
            setContacto2(copiaContacto);
        }
    };
    // maneja inputs de texto 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        
        setDatos(prevState => ({ ...prevState, [name]: value }));


        if (name === "rut") {
            const esRutValido = validarRut(value);
            setRutValido(esRutValido);
        }

        if (name === "celular") {
            const esCelValido = /^9\d{8}$/.test(value);
            setCelValido(datos.id_pais_domicilio === '1' ? esCelValido : true);
        }


        
    };

    const findUniversidad = (id) => {
        const universidadNombre = datosUniversidades.find(universidad => universidad.id === parseInt(id, 10));
        return universidadNombre ? universidadNombre.nombre : '';
    };

    const findUniversidadId = (nombre) => {

        const universidadId = datosUniversidades.find(universidad => universidad.nombre === nombre);
        return universidadId ? universidadId.id : '';
    };
    // inputs de select 
    const handleDropdownChange = (event) => {
        const { name, value } = event.target;
        setDatos(prevState => ({ ...prevState, [name]: value }));

        if (name === 'pueblo') {
            setSelectedPueblo(value);
        }
        if (name === 'selectedFactor') {
            setSelectedFactor(value);
        }
        if (name === 'selectedCompromiso') {    
            setSelectedCompromiso(value);
        }
        if (name === 'universidad') {
            setUniversidad(value);
            setDatos(prevState => ({ ...prevState, universidad: value }));
        }

        if (name === 'id_pais_domicilio') {
            const paisSeleccionado = datosPaises.find(pais => pais.id === parseInt(value, 10));
            if (paisSeleccionado) {
                const codigoAsociado = phoneCode.find(codigo => codigo.nombre === paisSeleccionado.pais);
                setCodigoTelefonico(codigoAsociado ? codigoAsociado.codigo : '');
            }
            setMostrarRegion(value === '1');
        }

        
    };

    //funcion para ir a la siguiente pagina
    // const handleNext = async () => {
    //     const token = localStorage.getItem('jwtToken');
    //     datos.contactos = [contacto1, contacto2];
    //     sendDataToBackend(token, datos); 
    //     setCurrentStep(prevStep => prevStep + 1);
    // };

    

    const handleNext = () => {
        const token = localStorage.getItem('jwtToken');
        datos.contactos = [contacto1, contacto2];
        sendDataToBackend(token, datos); 
        // Avanzar al siguiente paso
        const isLastCommonStep = currentStep === questions.length;
        const isLastIndustryStep = industryStepIndex >= 0 &&
                                   industryStepIndex === selectedIndustrias.length - 1 &&
                                   currentStep === questions.length + industryQuestions[selectedIndustrias[industryStepIndex]].length;

        if (isLastCommonStep && selectedIndustrias.length > 0 && industryStepIndex === -1) {
            setIndustryStepIndex(0); // Inicia las preguntas de industria
            setCurrentStep(questions.length + 1);
        } else if (isLastIndustryStep) {
            setIndustryStepIndex(-1);
            setCurrentStep(questions.length + selectedIndustrias.reduce((acc, id) => acc + (industryQuestions[id]?.length || 0), 0) + 1);
        } else {
            setCurrentStep((prev) => prev + 1);
        }
    };
    

    const handlePrev = () => {
        const token = localStorage.getItem('jwtToken');
        datos.contactos = [contacto1, contacto2];
        sendDataToBackend(token, datos); 
        const isFirstIndustryStep = industryStepIndex >= 0 && currentStep === questions.length + 1;
        if (isFirstIndustryStep) {
            setIndustryStepIndex((prev) => (prev > 0 ? prev - 1 : -1));
            setCurrentStep(questions.length);
        } else {
            setCurrentStep((prev) => prev - 1);
        }
    };

    const functionMappings = {
        handleInputChange,
        handleDropdownChange,
        handleSelectionChange,
        handleFileChange,
        handleContactos,
        rutValido,
        datosPaisesOptions: () => datosPaises.map((country) => ({
            value: country.id,
            label: country.pais,
        })),
        datosRegionOptions: () => datosRegion.map((region) => ({
            value: region.id,
            label: region.nombre,
        })),
        datosCarrerasOptions: () => datosCarreras.map((carrera) => ({
            value: carrera.id,
            label: carrera.nombre,
        })), 

        datosUniversidadesOptions: () => datosUniversidades.map((universidad) => ({
            value: universidad.id, 
            label: universidad.nombre,
        })),

        datosIndustriasOptions: () => datosIndustrias.map((industria) => ({
            value: industria.id, 
            label: industria.nombre_industria,
        })),

        yesNoOptions: () => [
            { value: '0', label: "No" },
            { value: '1' , label: "Sí"}
        ],

        aniosExperienciaOptions: () => aniosExperiencia.map((anios) => ({
            value: parseInt(anios.id), 
            label:`${anios.rango_experiencia_desde} - ${anios.rango_experiencia_hasta}`,
        })),

        competenciasOptions: () => competencias.map((competencia) => ({
            value: competencia.id, 
            label: competencia.competencia,
        })),

        areasExperienciaOptions: () => areasExperiencia.map((area) => ({
            value: area.id, 
            label: area.nombre,
        })),

        datosTamanoEquiposOptions: () => datosTamanoEquipos.map((tamano) => ({
            value: tamano.id, 
            label: tamano.rango,
        })),

        disponibilidadesOptions: () => disponibilidades.map((disponibilidad) => ({
            value: disponibilidad.id, 
            label: disponibilidad.disponibilidad,
        })),

        jornadasOptions: () => jornadas.map((jornada) => ({
            value: jornada.id, 
            label: jornada.tipoJornada,
        })),

        modalidadesOptions: () => modalidades.map((modalidad) => ({
            value: modalidad.id, 
            label: modalidad.tipoModalidad,
        })),

        idiomasOptions: () => idiomas.map((idioma) => ({
            value: idioma.id, 
            label: idioma.nombre,
        })),

        conocioOptions: () => conocio.map((wot) => ({
            value: wot.id, 
            label: wot.conocio,
        })),

        lenguajesOptions: () => datosLenguajesProgramacion.map((lenguaje) => ({
            value: lenguaje.id, 
            label: lenguaje.nombre,
        })), 

        tecnologiasOptions: () => datosTecnologias.map((tecnologia) => ({
            value: tecnologia.id, 
            label: tecnologia.nombre
        })),

        tipoDbOptions: () => datosTiposDb.map((tipo) => ({
            value: tipo.id, 
            label: tipo.nombre,
        })),

        plataformasOptions: () => datosPlataformas.map((plataforma) => ({
            value: plataforma.id, 
            label: plataforma.nombre, 
        })),

        cultivosExperienciaOptions: () => datosCultivos.map((cultivo) => ({
            value: cultivo.id, 
            label: cultivo.nombre,
        })),

        plagasOptions: () => datosControlPlagas.map((plaga) =>({
            value: plaga.id, 
            label: plaga.nombre,
        })),

        sistemasMecanicosOptions: () => datosSistemasMecanicos.map((sistema) =>({
            value: sistema.id, 
            label: sistema.nombre,
        })),

        mantenimientoOptions: () => [
            {value: 0, label: 'Preventivo'}, 
            {value: 1, label: 'Correctivo'}, 
            {value: 2, label: 'Ambos'}
        ],

        herramientasDiagnosticoOptions: () => datosHerramietasDiagnostico.map((herramienta) =>({
            value: herramienta.id, 
            label: herramienta.nombre,
        })),

        equiposExperienciaOptions: () => datosEquipos.map((equipo) => ({
            value: equipo.id, 
            label: equipo.nombre
        })),
    
        softwareGestionOptions: () => datosSoftGestion.map((soft) => ({
            value: soft.id, 
            label: soft.nombre
        })),

        tipoMineriaOptions: () => datosTipoMineria.map((tipo) => ({
            value: tipo.id, 
            label: tipo.nombre
        })),

        softwareMineroOptions: () => datosSoftMinero.map((soft) => ({
            value: soft.id, 
            label: soft.nombre
        })),

        procesosOptions: () => datosProcesosExtraccion.map((proceso) => ({
            value: proceso.id, 
            label: proceso.nombre
        })),

        codigoTelefonico: () => codigoTelefonico
    };
    
    
    // Función para procesar el JSON de la base de datos
    const processQuestionConfig = (rawConfig) => {
        return rawConfig.map((question) => {
            const processedQuestion = { ...question };
    
            // Asignar función onChange desde el mapeo si está especificada
            if (typeof question.questionConfig.onChange === 'string' && functionMappings[question.questionConfig.onChange]) {
                processedQuestion.onChange = functionMappings[question.questionConfig.onChange];
            }
    
            // Asignar opciones desde el mapeo de funciones si es una función
            if (typeof question.questionConfig.options === 'string' && functionMappings[question.questionConfig.options]) {
                processedQuestion.options = functionMappings[question.questionConfig.options]();
            }
            
            // Configurar valor inicial y validación, si aplica
            if (question.questionConfig.type === 'multi-select') {
                // Asigna el valor adecuado del estado correspondiente de selección múltiple
                switch (question.questionConfig.name) {
                    case 'industriasExperiencia':
                        processedQuestion.value = selectedIndustrias;
                        break;
                    case 'competencias':
                        processedQuestion.value = selectedCompetencias;
                        break;
                    case 'areas':
                        processedQuestion.value = selectedAreas;
                        break;
                    case 'idiomas':
                        processedQuestion.value = selectedIdiomas;
                        break;
                    case 'disponibilidad':
                        processedQuestion.value = selectedDisponibilidad;
                        break;
                    case 'lenguajesExperiencia': 
                        processedQuestion.value = selectedLenguajes;
                        break;
                    case 'tecnologiasExperiencia': 
                        processedQuestion.value = selectedTecnologias;
                        break;
                    case 'tipoDb': 
                        processedQuestion.value =selectedTiposDb;
                        break;
                    case 'cultivosExperiencia' : 
                        processedQuestion.value = selectedCultivos;
                        break;
                    case 'plagas': 
                        processedQuestion.value = selectedPlagas;
                        break;
                    case 'sistemasMecanicosExperiencia': 
                        processedQuestion.value = selectedSistemasMecanicos; 
                        break;
                    case 'experienciaMantenimiento':
                        processedQuestion.value = selectedMantenimiento; 
                        break;
                    case 'herramientasDiagnostico': 
                        processedQuestion.value = selectedHerramientasDiagnostico;
                        break;
                    case 'equiposExperiencia': 
                        processedQuestion.value = selectedEquiposExperiencia;
                        break;
                    case 'plataformasExperiencia': 
                        processedQuestion.value = selectedPlataformas;
                        break;
                    case 'softwareGestion': 
                        processedQuestion.value = selectedSoftwareGestion;
                        break;
                    case 'tipoMineria': 
                        processedQuestion.value = selectedTipoMineria;
                        break;
                    case 'softwareMinero': 
                        processedQuestion.value = selectedSoftwareMinero;
                        break;
                    case 'procesos': 
                        processedQuestion.value = selectedProcesos;
                        break;
                    default:
                        processedQuestion.value = [];
                }
            } else {
                // Para campos no multi-select, usa `datos` directamente
                processedQuestion.value = datos[question.questionConfig.name] || '';
            }
            processedQuestion.isFieldEmpty = !datos[question.questionConfig.name]; // Campo vacío si no hay datos
            if (question.questionConfig.name === "rut") processedQuestion.isValid = validarRut(datos.rut || ''); // Rut
            if (question.name === "celular") processedQuestion.isValid =celValido(datos.celular || ''); // Celular
            if (question.questionConfig.codigo && question.questionConfig.codigo === "codigoTelefonico") {
                processedQuestion.codigo = functionMappings[question.questionConfig.codigo]();
            }
            return processedQuestion;
        });
    };

    const combineAndProcessQuestions = () => {
        // Inicializar preguntas comunes
        const commonQuestions = questions.filter(q => q.questionConfig.step !== "dynamic");
        
        // Inicializar contador de step dinámico, empezando después de la industria (step 4)
        let dynamicStep = 5;
        let industrias = 0;

        // Agregar preguntas de industrias seleccionadas y asignar steps dinámicos
        const industryQuestionList = selectedIndustrias.flatMap(industry => {
            const industryId = industry.value;
            const industrySpecificQuestions = industryQuestions[industryId] || [];
            
            // Asignar a cada pregunta de esta industria el step actual y luego incrementar el step
            const questionsWithSteps = industrySpecificQuestions.map(question => ({
                ...question,
                questionConfig: {
                    ...question.questionConfig,
                    step: dynamicStep
                }
            }));
            
            if (industrySpecificQuestions.length > 0) {
                dynamicStep++;
                industrias++;
            }
            return questionsWithSteps;
        });

        // Ajusta los steps para el resto de las preguntas (que no son dinámicas)
        const adjustedCommonQuestions = commonQuestions.map((question) => ({
            ...question,
            questionConfig: {
                ...question.questionConfig,
                step: question.questionConfig.step >= 5
                    ? question.questionConfig.step + industrias
                    : question.questionConfig.step
            }
        }));

        // Combina las preguntas comunes ajustadas con las de industrias dinámicas
        const allProcessedQuestions = [
            ...adjustedCommonQuestions,
            ...industryQuestionList
        ];
        
        setProcessedQuestions(processQuestionConfig(allProcessedQuestions));
    };
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('jwtToken');
                const responseQuestions = await axios.get(`${process.env.REACT_APP_API_URL}/preguntas`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                )

                setQuestions(responseQuestions.data)
                const responseProfile = await axios.get(
                    `${process.env.REACT_APP_API_URL}/users/get_profile`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
                const profileData = responseProfile.data;
                setDatos(profileData)
    
                // Actualizar variables de estado no relacionadas con `datos` (selectedAreas, selectedCompetencias, etc.)
                setSelectedAreas(prevState => prevState.length === 0 ? profileData.areas.map(area => ({
                    value: area.id,
                    label: area.nombre
                })) : prevState);
    
                setSelectedCompetencias(prevState => prevState.length === 0 ? profileData.competencias.map(competencia => ({
                    value: competencia.id,
                    label: competencia.competencia
                })) : prevState);
    
                setSelectedIdiomas(prevState => prevState.length === 0 ? profileData.idiomas.map(idioma => ({
                    value: idioma.id,
                    label: idioma.nombre
                })) : prevState);
    
                setSelectedIndustrias(prevState => prevState.length === 0 ? profileData.industrias.map(industria => ({
                    value: industria.id,
                    label: industria.nombre_industria
                })) : prevState);
    
                setSelectedDisponibilidad(prevState => prevState.length === 0 ? profileData.disponibilidades.map(disponibilidad => ({
                    value: disponibilidad.id,
                    label: disponibilidad.disponibilidad
                })) : prevState);
    
                // Actualizar datos de contacto solo si es necesario
                setContacto1(prevState => prevState.length === 0 ? profileData.contactos_usuaria[0] || prevState : prevState);
                setContacto2(prevState => prevState.length === 0 ? profileData.contactos_usuaria[1] || prevState : prevState);
                
                profileData.respuesta.forEach((respuesta) => {
                    const {id_pregunta,  respuestas_lenguaje, respuestas_tecnologias, respuestas_tipos_db, respuestas_plataformas } = respuesta;
    
                    switch (id_pregunta) {
                        // Lenguajes de programación
                        case 60:
                            setSelectedLenguajes(respuestas_lenguaje.map(({ id_lenguaje }) => ({
                                value: id_lenguaje,
                                label: datosLenguajesProgramacion.find((lenguaje) => lenguaje.id === id_lenguaje)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                lenguajes: respuestas_lenguaje.map((lenguaje) => ({ id: lenguaje.id_lenguaje})),
                            }));
                            break;
                        // Tecnologías
                        case 64:
                            setSelectedTecnologias(respuestas_tecnologias.map(({ id_tecnologia }) => ({
                                value: id_tecnologia,
                                label: datosTecnologias.find((tecnologia) => tecnologia.id === id_tecnologia)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                tecnologias: respuestas_tecnologias.map((tecnologia) => ({ id: tecnologia.id_tecnologia})),
                            }));
                            break;
                        // Tipos de bases de datos
                        case 66:
                            setSelectedTiposDb(respuestas_tipos_db.map(({ id_tipo }) => ({
                                value: id_tipo,
                                label: datosTiposDb.find((tipoDb) => tipoDb.id === id_tipo)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                tiposDb: respuestas_tipos_db.map((tipo) => ({ id: tipo.id_tipo })),
                            }));
                            break;
                        // Plataformas
                        case 68:
                            setSelectedPlataformas(respuestas_plataformas.map(({ id_plataforma }) => ({
                                value: id_plataforma,
                                label: datosPlataformas.find((plataforma) => plataforma.id === id_plataforma)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                plataformas: respuestas_plataformas.map((plataforma) => ({ id: plataforma.id_plataforma})),
                            }));
                            break;
                        // Respuestas binarias (Si/No)
                        case 62:
                            setDatos((prevState) => ({
                                ...prevState,
                                ciberseguridad: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 61:
                            setDatos((prevState) => ({
                                ...prevState,
                                desarrolloSoftware: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 63:
                            setDatos((prevState) => ({
                                ...prevState,
                                redes: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 65:
                            setDatos((prevState) => ({
                                ...prevState,
                                baseDeDatos: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 67:
                            setDatos((prevState) => ({
                                ...prevState,
                                experienciaNube: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 69:
                            setSelectedSistemasMecanicos(respuesta.respuestas_sistemas_mecanicos.map(({ id_sistema }) => ({
                                value: id_sistema,
                                label: datosSistemasMecanicos.find((SistemaMecanico) => SistemaMecanico.id === id_sistema)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                sistemasMecanicosExperiencia: respuesta.respuestas_sistemas_mecanicos.map((sistema) => ({ id: sistema.id_sistema })),
                            }));
                            break;
                        case 70: 
                            setDatos((prevState) => ({
                                ...prevState,
                                experienciaMantenimiento: respuesta.respuesta === 'Preventivo' ? '0' : respuesta.respuesta === 'Correctivo' ? '1' : '2',
                            }));
                            break;
                            
                        case 71: 
                            setDatos((prevState) => ({
                                ...prevState,
                                fallasMecanicas: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 72: 
                            setSelectedHerramientasDiagnostico(respuesta.respuestas_herramientas.map(({ id_herramienta }) => ({
                                value: id_herramienta,
                                label: datosHerramietasDiagnostico.find((herramienta) => herramienta.id === id_herramienta)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                herramientasDiagnostico: respuesta.respuestas_herramientas.map((herramienta) => ({ id: herramienta.id_herramienta})),
                            }));
                            break;
                        case 73:
                            setSelectedEquiposExperiencia(respuesta.respuestas_equipo.map(({ id_equipo }) => ({
                                value: id_equipo,
                                label: datosEquipos.find((equipo) => equipo.id === id_equipo)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                equiposExperiencia: respuesta.respuestas_equipo.map((equipo) => ({ id: equipo.id_equipo})),
                            }));
                            break;
                        case 74: 
                            setDatos((prevState) => ({
                                ...prevState,
                                disenoMecanico: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 75: 
                            setSelectedCultivos(respuesta.respuestas_cultivo.map(({ id_cultivo }) => ({
                                value: id_cultivo,
                                label: datosCultivos.find((cultivo) => cultivo.id === id_cultivo)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                cultivos: respuesta.respuestas_cultivo.map((cultivo) => ({ id: cultivo.id_cultivo})),
                            }));
                            break; 
                        case 76: 
                            setDatos((prevState) => ({
                                ...prevState,
                                sistemasRiego: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 77: 
                            setDatos((prevState) => ({
                                ...prevState,
                                controlPlagas: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 78: 
                            setSelectedPlagas(respuesta.respuestas_plagas.map(({ id_plaga }) => ({
                                value: id_plaga,
                                label: datosControlPlagas.find((plaga) => plaga.id === id_plaga)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                plagas: respuesta.respuestas_plagas.map((plaga) => ({ id: plaga.id_plaga})),
                            }));
                            break; 
                        case 79: 
                            setDatos((prevState) => ({
                                ...prevState,
                                certificacionAgricola: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 80: 
                            setDatos((prevState) => ({
                                ...prevState,
                                tecnologiasAgricolas: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 81: 
                            setDatos((prevState) => ({
                                ...prevState,
                                optimizacionProcesos: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 82: 
                            setDatos((prevState) => ({
                                ...prevState,
                                herramientasMejora: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 83: 
                            setSelectedSoftwareGestion(respuesta.respuestas_software_gestion.map(({ id_software }) => ({
                                value: id_software,
                                label: datosSoftGestion.find((software) => software.id === id_software)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                softwareGestion: respuesta.respuestas_software_gestion.map((software) => ({ id: software.id_software})),
                            }));
                            break;
                        case 84:
                            setDatos((prevState) => ({
                                ...prevState,
                                cadenaSuministro: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 85: 
                            setDatos((prevState) => ({
                                ...prevState,
                                gestionProyectos: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 86: 
                            setSelectedTipoMineria(respuesta.respuestas_tipo_mineria.map(({ id_tipo }) => ({
                                value: id_tipo,
                                label: datosTipoMineria.find((tipoMineria) => tipoMineria.id === id_tipo)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                tipoMineria: respuesta.respuestas_tipo_mineria.map((tipoMineria) => ({ id: tipoMineria.id_tipo })),
                            }));
                            break;
                        case 87: 
                            setDatos((prevState) => ({
                                ...prevState,
                                mineriaPesada: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        case 88: 
                            setSelectedSoftwareMinero(respuesta.respuestas_software_minero.map(({ id_software }) => ({
                                value: id_software,
                                label: datosSoftMinero.find((software) => software.id === id_software)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                softwareMinero: respuesta.respuestas_software_minero.map((software) => ({ id: software.id_software })),
                            }));
                            break;
                        case 89: 
                            setDatos((prevState) => ({
                                ...prevState,
                                procesosExtraccion: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break; 
                        case 90: 
                            setSelectedProcesos(respuesta.respuestas_procesos.map(({ id_proceso }) => ({
                                value: id_proceso,
                                label: datosHerramietasDiagnostico.find((proceso) => proceso.id === id_proceso)?.nombre || '',
                            })));
                            setDatos((prevState) => ({
                                ...prevState,
                                procesos: respuesta.respuestas_procesos.map((proceso) => ({ id: proceso.id_proceso})),
                            }));
                            break; 
                        case 91: 
                            setDatos((prevState) => ({
                                ...prevState,
                                gestionSeguridad: respuesta.respuesta === 'Si' ? '1' : '0',
                            }));
                            break;
                        default:
                                break;
                        }
                    });
                setDatos(prevState => ({
                    ...prevState,
                    id_pais_domicilio: prevState.id_pais_domicilio || profileData.paisDomicilio?.id || '',
                    region_domicilio: prevState.region_domicilio || profileData.regionDomicilio?.id || '',
                    carrera: prevState.carrera || profileData.carreras_usuaria[0]?.id_carrera || '',
                    universidad: prevState.universidad || profileData.carreras_usuaria[0]?.id_universidad || '',
                    duracion: prevState.duracion || profileData.carreras_usuaria[0]?.duracion || '',
                    especialidad: prevState.especialidad || profileData.especialidad_usuaria[0]?.especialidad || '',
                    institucion_especialidad: prevState.institucion_especialidad || profileData.especialidad_usuaria[0]?.institucion || '',
                    ano_especialidad: prevState.ano_especialidad || profileData.especialidad_usuaria[0]?.ano || '',
                    certificacion: prevState.certificacion || profileData.certificacion_usuaria[0]?.certificacion || '',
                    institucion_certificacion: prevState.institucion_certificacion || profileData.certificacion_usuaria[0]?.institucion || '',
                    ano_certificacion: prevState.ano_certificacion || profileData.certificacion_usuaria[0]?.ano || '',
                    cargo_actual: prevState.cargo_actual || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 1)?.cargo || '',
                    empresa_actual: prevState.empresa_actual || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 1)?.empresa || '',
                    id_industria_actual: prevState.id_industria_actual || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 1)?.id_industria || '',
                    cargo_adicional: prevState.cargo_adicional || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 2)?.cargo || '',
                    empresa_adicional: prevState.empresa_adicional || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 2)?.empresa || '',
                    id_industria_adicional: prevState.id_industria_adicional || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 2)?.id_industria || '',
                    cargo_relevante: prevState.cargo_relevante || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 3)?.cargo || '',
                    empresa_relevante: prevState.empresa_relevante || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 3)?.empresa || '',
                    id_industria_relevante: prevState.id_industria_relevante || profileData.cargos_usuarias.find(cargo => cargo.id_tipo === 3)?.id_industria || '',
                    id_anios_experiencia: prevState.id_anios_experiencia || profileData.aniosExperiencia?.id || '',
                    id_jornada: prevState.id_jornada || profileData.jornada?.id || '',
                    id_modalidad: prevState.id_modalidad || profileData.modalidad?.id || '',
                    id_conocio_wot: prevState.id_conocio_wot || profileData.conocioWot?.id || ''
                }));
            } catch (error) {
                console.error('Error al obtener datos:', error);
            }
        };
        fetchData();
    }, []);
    

    useEffect(() => {
        const fetchIndustryQuestions = async () => {
            const token = localStorage.getItem('jwtToken');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/preguntas/industria`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            const groupedByIndustry = response.data.reduce((acc, question) => {
                const { id_industria } = question;
                if (!acc[id_industria]) acc[id_industria] = [];
                acc[id_industria].push(question);
                return acc;
            }, {});
            setIndustryQuestions(groupedByIndustry);
            console.log('industrias',industryQuestions);
        };
        console.log(selectedIndustrias)
        if (selectedIndustrias.length > 0) fetchIndustryQuestions();
    }, [selectedIndustrias]);

    useEffect(() => {
        console.log('hola')
        combineAndProcessQuestions();
    }, [questions, selectedIndustrias, industryQuestions,datos]);

   
    console.log(datos)
    console.log('tipos db', selectedTiposDb)
    return (
        <div>
            <Header />
            <img src={cityImage} alt="City Background" className="image-city" />
            <div className='fondo_rosado'></div>
            <div className='fondo_blanco'></div>
            
            <div className='container-preguntas'>
                <div className="horizontal-bar-form">
                    <button className={currentStep === 1 ? "button-activate-infoprofesional-form" : "button-inactivate-infoprofesional-form"} onClick={() => setCurrentStep(1)}>Información personal</button>
                    <button className={(currentStep >= 2 && currentStep <= 5) ? "button-activate-form" : "button-inactivate-form"} onClick={() => setCurrentStep(2)}>Información profesional</button>
                    <button className={currentStep === 6 ? "button-activate-infoadicional-form" : "button-inactivate-infoadicional-form"} onClick={() => setCurrentStep(6)}>Disponibilidad</button>
                    <button className={(currentStep === 7 || currentStep === 9) ? "button-activate-form" : "button-inactivate-form"} onClick={() => setCurrentStep(7)}>Información adicional</button>
                    <button className={(currentStep === 10 || currentStep === 11) ? "button-activate-form" : "button-inactivate-form"} onClick={() => setCurrentStep(10)}>Referencias</button>
                    <button className="close-button" onClick={handleSubmit}><FaTimes /></button>
                </div>

                <div className='container_pregunta'>
                    {/* Mostrar mensaje de carga si las preguntas no están listas */}
                    {questions.length === 0 ? (
                        <p>Cargando preguntas...</p>
                    ) : (
                        processedQuestions
                            .filter(question => question.questionConfig.step === currentStep)
                            .map((question) => (
                                <Question
                                    key={question.questionConfig.name}
                                    label={question.questionConfig.label}
                                    description={question.questionConfig.description}
                                    name={question.questionConfig.name}
                                    value={question.value}
                                    onChange={question.onChange || handleInputChange}
                                    isFieldEmpty={question.isFieldEmpty}
                                    isValid={question.isValid}
                                    invalidMessage={question.questionConfig.invalidMessage}
                                    type={question.questionConfig.type || 'text'}
                                    options={question.options || []}
                                    isVisible={question.questionConfig.isVisible !== undefined ? question.questionConfig.isVisible : true}
                                    codigo={question.codigo}
                                    placeholder={question.questionConfig.placeholder}
                                    handleFile={question.questionConfig.name === 'pdfFile' ? handleFile : null}
                                />
                            ))
                    )}
                </div>

                <div className='button-container-form'>
                    {currentStep !== 1 && (
                        <BackButton handleBack={handlePrev} buttonText="Anterior" buttonColor="#5A5A5A" marginTopMobile='-8rem' />
                    )}
                    {currentStep === 1 && (
                        <BackButton buttonText="Anterior" buttonColor="#d3d3d3" disabled={true} marginTopMobile='-8rem' />
                    )}
                    
                    {/* Mostrar "Siguiente" si hay pasos después del `currentStep` en `processedQuestions` */}
                    {processedQuestions.some(q => q.questionConfig.step > currentStep) ? (
                        <NextButton handleNext={handleNext} buttonText="Siguiente" buttonColor="#E6007E" marginTopMobile='-17rem' />
                    ) : (
                        <NextButton handleNext={handleSubmit} buttonText="Enviar" buttonColor="#E6007E" marginTopMobile='-17rem' />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Form;
